import axios from 'axios';
import PropTypes from 'prop-types';
import { useAuth } from '@acast-tech/auth-client';
import { useQuery } from '@tanstack/react-query';

const useApiQuery = ({
  requestUrl,
  queryKey,
  method = 'GET',
  disabled = false,
  refetchInterval,
  refetchOnMount,
  baseUrl,
  staleTime,
}) => {
  const { getToken } = useAuth();

  const queryData = {
    queryKey,
    queryFn: async () => {
      const token = await getToken();

      const axiosClient = axios.create({
        baseURL: baseUrl || '/api',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const res = await axiosClient(requestUrl, { method });
      return res.data;
    },
    enabled: !disabled,
  };

  if (refetchInterval) {
    queryData.refetchInterval = refetchInterval;
  }

  if (refetchOnMount) {
    queryData.refetchOnMount = refetchOnMount;
  }

  if (staleTime) {
    queryData.staleTime = staleTime;
  }

  const query = useQuery(queryData);

  return query;
};

useApiQuery.propTypes = {
  requestUrl: PropTypes.string.isRequired,
  queryKey: PropTypes.array.isRequired,
  method: PropTypes.oneOf(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
  disabled: PropTypes.bool,
  path: PropTypes.object,
  refetchInterval: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  refetchOnMount: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default useApiQuery;
